export function createTachoChart(element) {
	return {
		chart: null,

		init(simulationserfolg) {
			this.chart = new Highcharts.Chart(element, {
				chart: {
					type: "gauge",
					height: 84,
					width: 160,
					marginBottom: 5,
					plotBackgroundImage: "/images/tacho.png",
				},

				pane: {
					startAngle: -90,
					endAngle: 90,
					background: null,
					center: ["50%", "100%"],
					size: 100,
				},

				tooltip: {
					enabled: false,
				},

				yAxis: {
					min: 0,
					max: 100,
					minorTickLength: 0,
					tickLength: 0,
					lineColor: "transparent",

					title: {
						text: undefined,
					},

					labels: {
						enabled: false,
					},
				},

				plotOptions: {
					gauge: {
						dataLabels: {
							borderWidth: 0,
							useHTML: true,
							style: {
								fontSize: "24px",
								color: chartFontColorGrau,
								fontWeight: "500",
							},
						},
						dial: {
							radius: "125%",
							backgroundColor: chartFontColorGrau,
							rearLength: "0%",
							baseWidth: 4,
						},
						pivot: {
							backgroundColor: "#FFFFFF",
							radius: 32,
						},
					},
				},

				series: [
					{
						data: [simulationserfolg],
					},
				],
			})
		},

		update(simulationserfolg) {
			if (!this.chart) {
				this.init(simulationserfolg)
				return
			}

			this.chart.series[0].setData([simulationserfolg], false)
			this.chart.redraw({ duration: chartAnimationDuration })
		},

		destroy() {
			this.chart?.destroy()
			this.chart = null
		},
	}
}
